const data = [
  {
    id: "1",
    slug: "ruben-robles",
    banner:
      "https://tarjetaejecutiva.com.mx/wp-content/uploads/2023/10/banner-upper-tarjeta-ejecutiva-c.png",
    avatar:
      "https://tarjetaejecutiva.com.mx/wp-content/uploads/2024/08/Ru-e1724395758112.jpg",
    name: "Rubén Robles",
    jobPosition: "Ser Humano",
    buttons: {
      website: "https://robledigital.com",
      location: "https://maps.app.goo.gl/bmwVgdrToA1jHD889",
      phone: "5560809973",
      email: {
        address: "ruben@robledital.com",
        subject: "Me interesa conectar",
        message: "Hola estoy interesado conocer sus soluciones.",
      },
      social: {
        facebook: null,
        twitter: "https://x.com/",
        instagram: "https://www.instagram.com/rubsrc/",
        tiktok: undefined,
        linkedin: "https://www.linkedin.com/in/ruben-robles-cortes/",
      },
      vcfFile:
        "https://tarjetaejecutiva.com.mx/wp-content/uploads/2024/08/RubenRobles.vcf",
      qrCode:
        "https://tarjetaejecutiva.com.mx/wp-content/uploads/2024/08/RubenRobles-QR.png",
      vcfQrCode:
        "https://tarjetaejecutiva.com.mx/wp-content/uploads/2024/08/RubenRobles-VCF-QR.png",
    },
    slogan: "Software Engineer. Entrepeneur. Husband. Dad.",
  },
  {
    id: "2",
    slug: "nombre-apellido",
    banner:
      "https://tarjetaejecutiva.com.mx/wp-content/uploads/2023/10/banner-upper-tarjeta-ejecutiva-c.png",
    avatar:
      "https://tarjetaejecutiva.com.mx/wp-content/uploads/2023/10/demo-profile-pic.png",
    name: "Nombre Apellido",
    jobPosition: "Ser Humano",
    buttons: {
      website: "https://robledigital.com",
      location: "https://maps.app.goo.gl/bmwVgdrToA1jHD889",
      phone: "5560809973",
      email: {
        address: "ruben@robledital.com",
        subject: "Me interesa conectar",
        message: "Hola estoy interesado conocer sus soluciones.",
      },
      social: {
        facebook: "https://www.facebook.com/",
        twitter: "https://x.com/",
        instagram: "https://www.instagram.com/",
        tiktok: "https://www.tiktok.com/",
        linkedin: "https://www.linkedin.com/",
      },
      vcfFile:
        "https://tarjetaejecutiva.com.mx/wp-content/uploads/2024/08/RubenRobles.vcf",
      qrCode:
        "https://tarjetaejecutiva.com.mx/wp-content/uploads/2024/08/RubenRobles-QR.png",
      vcfQrCode:
        "https://tarjetaejecutiva.com.mx/wp-content/uploads/2024/08/RubenRobles-VCF-QR.png",
    },
    slogan:
      "loremLorem ipsum dolor sit amet consectetur adipisicing elit. Hic mollitia consectetur a, laboriosam consequatur, similique temporibus, recusandae magnam laborum odit magni repellendus harum debitis dolore tempore sit sequi sunt et?",
  },
];

export default data;
